export const GET_MESSAGES = 'GET_MESSAGES';
export const SENT_MESSAGES = 'SENT_MESSAGES';
export const ON_SENT_MESSAGES = 'ON_SENT_MESSAGES';